import React, { useState, useEffect, useCallback } from 'react';
import { fmt, api } from '../utils/api';
import CollapsiblePanel from './CollapsiblePanel';

export default function InvestmentsSnapshot({ refreshKey }) {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    try {
      const d = await api.getInvestments();
      setData(d);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => { load(); }, [load, refreshKey]);

  if (!data) return null;

  return (
    <CollapsiblePanel title="💎 Investments">
      <ChangeRow label="Total Net Worth" value={data.totalNetWorth} dailyChange={data.totalNetWorthChangeToday} dailyLabel={data.dailyChangeLabel} monthlyChange={data.totalNetWorthChangeThisMonth} />
      <ChangeRow label="Liquid Net Worth" value={data.liquidNetWorth} dailyChange={data.liquidNetWorthChangeToday} dailyLabel={data.dailyChangeLabel} monthlyChange={data.liquidNetWorthChangeThisMonth} />
    </CollapsiblePanel>
  );
}

function ChangeRow({ label, value, dailyChange, dailyLabel, monthlyChange }) {
  return (
    <div style={styles.row}>
      <div style={styles.rowTop}>
        <span style={styles.label}>{label}</span>
        <span style={styles.value}>{fmt.currency(value)}</span>
      </div>
      <div style={styles.changeLine}>
        {dailyChange === null ? (
          <span style={styles.noData}>No prior data yet</span>
        ) : (
          <ChangeBadge amount={dailyChange} suffix={dailyLabel || 'today'} />
        )}
        <ChangeBadge amount={monthlyChange} suffix="this month" />
      </div>
    </div>
  );
}

function ChangeBadge({ amount, suffix }) {
  const up = amount >= 0;
  const color = up ? '#00d4aa' : '#ef4444';
  return (
    <span style={{ ...styles.change, color }}>
      {up ? '▲' : '▼'} {fmt.currency(Math.abs(amount))} {suffix}
    </span>
  );
}

const styles = {
  row: { marginBottom: '0.85rem' },
  rowTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginBottom: '2px',
  },
  label: {
    color: '#9ca3af',
    fontSize: '0.78rem',
    fontFamily: "'Syne', sans-serif",
  },
  value: {
    color: '#fff',
    fontSize: '1rem',
    fontWeight: '700',
    fontFamily: "'DM Mono', monospace",
  },
  change: {
    fontSize: '0.72rem',
    fontWeight: '600',
    fontFamily: "'DM Mono', monospace",
  },
  changeLine: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  noData: {
    fontSize: '0.7rem',
    color: '#4b5563',
    fontStyle: 'italic',
  },
};
